/**
 *
 * @param {Object} param
 * @param {string} param.insurer_name
 * @param {(event: MouseEvent) => void} param.onClick
 *
 * @returns
 */
export const Acknowledgement = ({ insurer_name, onClick }) => {
	if (insurer_name === "ALLIANZ") {
		return (
			<span>
				I confirm that I have read and understood the{" "}
				<a href="https://getquote.allianz.com.my/motor-online/assets/allianz/forms/PDS_MT.pdf"
					target="_blank"
					className="color-primary"
					rel="noopener noreferrer"
				>
					Product Disclosure Sheet
				</a>
				,{" "}
				<a href="https://www.allianz.com.my/content/dam/onemarketing/azmb/wwwallianzcommy/personal/home-motor-and-travel/car-and-motorcycle/car-and-motor-comprehensive-cover/CommercialVehiclePolicyWording_Eng-2301.pdf"
					target="_blank"
					className="color-primary"
					rel="noopener noreferrer"
				>
					Certificate/Policy Wording
				</a>{" "}
				&{" "}
				<a
					href="https://www.allianz.com.my/content/dam/onemarketing/azmb/wwwallianzcommy/pdf/privacy-statement/AGIC-Privacy-Notice-2010.pdf?=07102024"
					target="_blank"
					className="color-primary"
					rel="noopener noreferrer"
				>
					Privacy Notice
				</a>{" "}
				and agree to the processing of my personal data for the purposes
				stated in the Privacy Notice.
			</span>
		);
	}

	if (insurer_name === "LIBERTY") {
		return (
			<>
				<span>
					I hereby acknowledge the commission entitled by "Advance Fin
					Advisory Sdn Bhd" for my purchase of Takaful/Insurance product(s)
					and that I have read and agreed to the
				</span>
				<a
					href={
						insurer_name === "LIBERTY"
							? "https://www.ansa.my/wp-content/uploads/2025/09/ANSA_DIGITAL_Terms_and_Conditions.pdf"
							: "#"
					}
					target="_blank"
					className="color-primary"
					rel="noopener noreferrer"
					onClick={(e) => {
						onClick(e);
					}}
				>
					{` Terms and Conditions`}
				</a>

				<span>{` and `}</span>
				<a
					href="https://www.liberty.my/images/PrivacyNotice.pdf"
					className="color-primary"
					target="_blank"
					rel="noopener noreferrer"
				>
					{`Privacy Notice`}
				</a>
			</>
		);
	}

	if (insurer_name === "LONPAC") {
		return (
			<>
				<span>I agree to the</span>
				<a
					href={"#"}
					target="_blank"
					className="color-primary"
					rel="noopener noreferrer"
					onClick={(e) => {
						onClick(e);
					}}
				>
					{` Terms and Conditions`}
				</a>
				<span>{` of this platform`}</span>
			</>
		);
	}

	if (insurer_name === "ETIQA") {
		return (
			<>
				<span>
					I acknowledge and accept that Advance Fin Advisory Sdn Bhd
					will receive a commission for my purchase of takaful/insurance
					product(s), and I agree to the
				</span>

				<a
					href={
						"https://www.ansa.my/wp-content/uploads/2025/09/ANSA_DIGITAL_Terms_and_Conditions.pdf"
					}
					target="_blank"
					className="color-primary"
					rel="noopener noreferrer"
					onClick={(e) => {
						// setIsAckVisible(true);
						// setHasOpenedAck(true);
						// setCheckAck(true); // Ensure checkbox is checked when the link is clicked
					}}
				>
					{` Terms and Conditions`}
				</a>
				<span>{` and `}</span>
				<a
					href="https://www.ansa.my/wp-content/uploads/2025/07/AFA_SERVICE_GUIDE.pdf"
					className="color-primary"
					target="_blank"
					rel="noopener noreferrer"
				>
					{`Service Guide`}
				</a>
			</>
		);
	}

	if (insurer_name === "TUNE PROTECT") {
		return (
			<>
				<span>
					I/We hereby agree for my personal data be used to receive marketing content and promotional offers 
					from Tune Protect Group and its affiliated companies. I further understand that I may withdraw such 
					consent in accordance with terms under Tune Protect's Privacy Policy 
					(<a href="https://www.tuneprotect.com/my/privacy-policy/" target="_blank">https://www.tuneprotect.com/my/privacy-policy/</a>).
				</span>
			</>
		);
	}

	return (
		<>
			<span>
				I acknowledge and accept that Advance Fin Advisory Sdn Bhd will
				receive a commission for my purchase of takaful/insurance product(s),
				and I agree to the
			</span>
			<a
				href={"#"}
				target="_blank"
				className="color-primary"
				rel="noopener noreferrer"
				onClick={(e) => {
					onClick(e);
				}}
			>
				{` Terms and Conditions`}
			</a>
		</>
	);
};
